import React, { useState } from 'react';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_EMAIL_SERVICES,
} from '../../../../../constants/RoleConsts';
import {
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  InputAdornment,
} from '@material-ui/core';
import { GUEST_EDIT, GUEST_VIEW } from '../../../../../constants/EmailServicesConst';
import { MoreHoriz } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import './PropertyList.scss';
import SearchIcon from '@material-ui/icons/Search';
import CreateIcon from '@mui/icons-material/Create';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const PropertyList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const [guestEmailList, setGuestEmailList] = useState([{ name: 'Property Mobile app invite' }]);
  const [searchText, setSearchText] = useState('');
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
  });

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onOpenDrawer = (event, type) => {
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.group);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      group: null,
    });
  };

  const onViewDetails = (category, e) => {
    if (
      e.target.className === 'MuiTableCell-root MuiTableCell-body' ||
      e.target.className === 'MuiTableCell-root MuiTableCell-body MuiTableCell-alignCenter' ||
      e.target.className === 'MuiTableCell-root MuiTableCell-body MuiTableCell-alignRight' ||
      e.target.className === 'custom-chip' ||
      e.target.className === 'MuiChip-label'
    ) {
      onViewToggle(GUEST_VIEW, true, category);
    }
  };

  const handleCellMenuClick = (event, item) => {
    setSelectedValue({
      id: item.id,
      name: item.name,
      title: '',
      description: '',
      status: false,
      isActive: item.isActive,
      anchorEl: event.currentTarget,
      group: item,
    });
  };

  const dispatch = useDispatch();

  return (
    <div>
      <div className='row m-2 d-flex px-2'>
        <div className='col-12 col-lg-4'>
          <TextField
            className='w-100'
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            label='Search'
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>
      <TableContainer className='property-list-table mt-4'>
        <Table className='list-table' aria-label='simple table'>
          <TableHead>
            <TableRow className='border-white pointer'>
              <TableCell className='w-75'>Name</TableCell>
              <TableCell className='w-25'></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? guestEmailList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : guestEmailList
            ).map((item, i) => (
              <TableRow
                key={i}
                className='border-white pointer'
                onClick={(e) => {
                  onViewDetails(item, e);
                }}
              >
                <TableCell>{item.name}</TableCell>
                <TableCell className='kebab-menu' align='right'>
                  {permissions[RBAC_TYPE_EMAIL_SERVICES] === RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                    <Button
                      aria-controls='simple-menu'
                      aria-haspopup='true'
                      onClick={(e) => {
                        handleCellMenuClick(e, item);
                      }}
                    >
                      <MoreHoriz />
                    </Button>
                  )}
                  <Menu
                    id={i}
                    anchorEl={selectedValue?.anchorEl}
                    disableRestoreFocus
                    MenuListProps={{ autoFocusItem: false }}
                    keepMounted
                    open={Boolean(selectedValue.anchorEl)}
                    onClose={handleClose}
                    className='shadow'
                  >
                    <MenuItem
                      className='pe-4'
                      onClick={(e) => {
                        onOpenDrawer(e, GUEST_EDIT);
                      }}
                    >
                      <CheckBoxIcon className='me-2 action-menu-icon' />
                      Mark for Publish
                    </MenuItem>
                    <MenuItem
                      className='pe-4'
                      onClick={(e) => {
                        onOpenDrawer(e, GUEST_EDIT);
                      }}
                    >
                      <CreateIcon className='me-2 action-menu-icon' />
                      Edit details
                    </MenuItem>
                    <MenuItem
                      className='pe-4'
                      onClick={(e) => {
                        onOpenDrawer(e, GUEST_EDIT);
                      }}
                    >
                      <CreateIcon className='me-2 action-menu-icon' />
                      Edit template
                    </MenuItem>
                  </Menu>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow className='paginator'>
              <TablePagination
                rowsPerPageOptions={[10, 25, { label: 'All', value: -1 }]}
                count={guestEmailList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </div>
  );
};

export default PropertyList;
